var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"ledger-modal-nano-s",attrs:{"src":require("../../assets/ledger-nano-s.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }